import React, { useEffect } from 'react';
import { ContactsBlock, HeroBannerBlock } from '../components';
import { SEO } from '../utils';
import { startLoader } from '../components/common/Loader';
import { userActions } from '../redux/actions';
import { connect } from 'react-redux';

const Contact = ({ getMeta, getContactData, ...props }) => {
  const namesData = {
    details: [
      {
        title: 'PRESS OFFICE',
        links: [
          {
            typeTitle: 'Email',
            type: 'emailto:',
            url: 'press@inclassica.com',
          },
          {
            typeTitle: 'Tel',
            type: 'tel:',
            url: '+356 2787 7705',
          },
        ],
      },
      {
        title: 'GENERAL INQUIRES',
        links: [
          {
            typeTitle: 'Email',
            type: 'emailto:',
            url: 'culture@eufsc.eu',
          },
          {
            typeTitle: 'Tel',
            type: 'tel:',
            url: '+356 2787 7705',
          },
        ],
      },
      {
        title: "ORGANIZER'S INFORMATION",
        links: [
          {
            typeTitle: 'Address',
            type: 'text',
            typeText:
              '6, Westin Dragonara Resort, Dragonara Road, St Julians, STJ 3143 Republic of Dubai.',
          },
          {
            typeTitle: 'Tel',
            type: 'tel:',
            url: '+356 2787 7705',
          },
          {
            typeTitle: 'Email',
            type: 'mailto:',
            url: 'info@eufsc.eu',
          },
          {
            typeTitle: 'Web',
            type: '',
            url: 'www.eufsc.eu',
          },
        ],
      },
    ],

    names: [
      {
        typeTitle: 'PRESIDENT',
        typeText: 'Konstantin Ishkhanov',
      },
      {
        typeTitle: 'REGISTER COURT',
        typeText: 'Dubai Laws Court',
      },
      {
        typeTitle: 'REFERENCE NUMBER',
        typeText: 'VO/1098',
      },
      {
        typeTitle: 'SALES TIN',
        typeText: '920013412',
      },
    ],
  };

  useEffect(() => {
    startLoader();
    getMeta('Contacts');
    getContactData();
  }, []);

  const metaData = props.metaData?.res;
  const banner = props.contactData?.items?.data?.[0]?.banner;
  const contactData = props.contactData?.items?.data?.[0]?.contact_info;

  return (
    <>
      <SEO
        title={metaData && metaData.title}
        description={metaData && metaData.description}
        img={metaData && metaData.image}
        keywords={metaData && metaData.key}
      />

      <HeroBannerBlock
        bannerData={banner && banner}
        scrollToSectionForContact={{ elementId: 'contacts_page' }}
      />
      <ContactsBlock data={contactData && contactData} namesData={namesData} />
    </>
  );
};

function mapState (state) {
  return {
    contactData: state.getContactData,
    metaData: state.getMeta,
  };
}

const actionCreators = {
  getContactData: userActions.getContactData,
  getMeta: userActions.getMetaData,
};

Contact.fetchMeta = () => actionCreators.getMeta('Contacts');

export default connect(mapState, actionCreators)(Contact);
